import { BACKEND_URL } from './../../../app.constants';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppState } from '../../../models/app.state';
import { Store } from '@ngrx/store';
import { ChangeLanguageAction } from '../../../actions/lang.action';
import { Router } from '@angular/router';
import { CookieService } from '../../../shared/cookie.service';

@Component({
  selector: 'ciu-desktop-menu',
  templateUrl: './desktop-menu.component.html',
  styleUrls: ['./desktop-menu.component.css']
})
export class DesktopMenuComponent implements OnInit {
  BACKEND_URL: string;

  constructor(public translateService: TranslateService, private store: Store<AppState>, private router: Router,
    private cookiesService: CookieService) { this.BACKEND_URL = BACKEND_URL; }

  currentLang: string;

  ngOnInit() {
    this.currentLang = 'it'
  }

  changeLanguage(lang: 'de' | 'en' | 'it' | 'fr') {
    this.currentLang = lang;
    this.translateService.use(lang);
    this.cookiesService.updateCookiesLang();
    this.store.dispatch(new ChangeLanguageAction(lang))
  }

  navigateHome() {
    //this.service
    if (this.router.url.includes('home') || this.router.url.includes('product')) {
      return null;
    } else {
      return 'preserve';
    }
  }

  navigateToWindow() {
    //this.service
    if (this.router.url.includes('window')) {
      return null;
    } else {
      return 'preserve';
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/header/main-menu/desktop-menu/desktop-menu.component.ts